export interface SocialLink {
  label: string
  href: string
  icon: string
}

const x: SocialLink = { label: 'X', href: 'https://x.com/forgd_', icon: '/icons/twitter.svg' }
const substack: SocialLink = { label: 'Substack', href: 'https://content.forgd.com/', icon: '/icons/substack.svg' }
const youtube: SocialLink = { label: 'YouTube', href: 'https://www.youtube.com/@forgd_', icon: '/icons/youtube.svg' }
const linkedIn: SocialLink = { label: 'LinkedIn', href: 'https://www.linkedin.com/company/forgdd/', icon: '/icons/linked-in.svg' }

export const socialLinks: SocialLink[] = [x, youtube, linkedIn]

export const mobileSocialLinks: SocialLink[] = [x, substack, youtube, linkedIn]

export const externalLinks = {
  home: 'https://forgd.com/',
  about: 'https://forgd.com/about',
  pricing: 'https://forgd.com/pricing',
  contact: 'https://forgd.com/contact',
  tools: 'https://forgd.com/tools',
  terms: 'https://forgd.com/terms-conditions',
  privacy: 'https://forgd.com/privacy-policy',
  faqTools: 'https://forgd.com/faq#tools',
  faqAbout: 'https://forgd.com/faq#about',
  questionnaire: 'https://forms.monday.com/forms/aee2322c033faec19f3e3180c5d05b53?r=use1',
  sampleDailyData: 'https://docs.google.com/spreadsheets/d/1MqSYwa_ou87FkPkyumxTQqZqy3e723HW5Cv8CRLiBP4/edit?gid=36282191#gid=36282191',
} as const
